import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetNationalitiesResp } from '../types/nationality'

export const getNationalities = () => api.get<GetNationalitiesResp>('/nationalities')
